import {ContentEditableEditorDecoration, ContentEditableEditorPlugin} from '@frontapp/editor-html';

import {getRegexpMatches} from '../../../../../../libs/shared/core/src/helpers/utilities/stringHelpers';

/*
 * Types.
 */

export interface MentionPluginOptions {
  className: string;
  isValidMention?: MentionValidator;
}

export type MentionValidator = (mention: string) => boolean;

/*
 * Constants.
 */

const decorateRegExp = /(?:^|\W)(@\w\S*[\w\d])/g;

/*
 * Plugin.
 */

export function createMentionPlugin(options: MentionPluginOptions): ContentEditableEditorPlugin {
  return {
    decorateText: (text) => decorateText(text, options),
  };
}

function decorateText(text: string, options: MentionPluginOptions): ContentEditableEditorDecoration[] {
  const {className, isValidMention} = options;

  return getRegexpMatches(decorateRegExp, text)
    .filter((match) => {
      const mention = match[1];
      return !isValidMention || isValidMention(mention);
    })
    .map((match) => {
      const before = match[0];
      const mention = match[1];

      return {
        index: match.index + before.length - mention.length,
        length: mention.length,
        className,
        shouldDisableSpellcheck: true,
      };
    });
}
